import React, { JSXElementConstructor, MouseEventHandler, PropsWithChildren, ReactElement } from 'react';
import classNames from 'classnames';
import { noop } from 'lodash';
import { List } from '../list/List';
import { ListItem } from '../list/ListItem';
import styles from './FlyIn.module.scss';

export const FlyIn = ({
    className,
    children, hide, from,
    ToggleButton = () => null
}: Props) => {

    const navClassName = classNames(className, styles.nav, styles[from]);

    const onClick: MouseEventHandler = (e) => {
        // prevents permanent open state when <FlyIn /> is opened by clicking its parent component
        e.stopPropagation();
        hide();
    };

    return (
        <div className={styles.container}>
            <div onClick={onClick} className={styles.backdrop} />
            <ToggleButton />
            <List className={navClassName}>
                {children}
            </List>
        </div>
    );
};

FlyIn.MenuItem = ({ className, icon, onClick = noop, children }: MenuItemProps) => (
    <ListItem className={classNames(className, styles.item)} onClick={onClick}>
        {icon && (
            <div className={styles.icon}>{icon}</div>
        )}

        {children}
    </ListItem>
);

type Props = {
    from: 'top' | 'right' | 'bottom' | 'left';
    ToggleButton?: () => ReactElement | null;
    className?: string;
    hide: () => void;
    children: MenuItem | MenuItem[];
};

type MenuItem = ReactElement<MenuItemProps, JSXElementConstructor<MenuItemProps>>;
type MenuItemProps = PropsWithChildren<{
    icon?: JSX.Element;
    className?: string;
    onClick?: MouseEventHandler;
}>;